export enum ToastTypeEnum {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  QUESTION = "question",
}

export enum UserRoles {
  //ROLE_ADMIN, ROLE_INTER, ROLE_SELLER, ROLE_ACCOUNTANT, ROLE_STOCK_MANAGER
  ADMIN = "ROLE_ADMIN",
  STOCK_MANAGER = "ROLE_STOCK_MANAGER",
  ACCOUNTANT = "ROLE_ACCOUNTANT",
  SELLER = "ROLE_SELLER",
  INTER = "ROLE_INTERN",
}

export enum ACCOUNT_STATUS {
  ACTIF = "ACTIF",
  INACTIF = "INACTIF",
}
